"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "properties/5.0.1";
